module.exports = __webpack_public_path__ + "img/sidebar-icon-master-data.3372b6b9.svg";